<template>
  <v-card class="product-details-actions">
    <v-card-text class="py-5 px-7">
      <p class="product-details-actions-subtitle">Onde essas ofertas estão válidas?</p>
      <v-row align="center">
        <v-col :cols="isMobile ? 12 : 4">
          <mf-select-units-dialog
            outlined
            label="Lojas"
            :disabled="disableFields"
            :selected-units.sync="selectedUnits"
            :selected-units-configuration.sync="selectedUnitsConfiguration"
            hide-ecommerce-configuration
            :unit-error="unitError"
            :maria-campaign="mariaCampaign"
            :units="allUnits"
            :tag-list="tagList"
            :group-list="unitsGroups"
            :default-data-type="defaultDataType"
          />
        </v-col>
        <v-col :cols="isMobile ? 12 : 4">
          <mf-date-range-picker
            icon
            outlined
            label="Período de validade"
            :min="minInitialDate"
            :initial-date.sync="selectedStartDate"
            :final-date.sync="selectedEndDate"
            :disabled="disableFields"
            :error-messages="errorMessages"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductDetailsActions',
  props: {
    units: {
      type: Array,
      default: () => [],
    },
    unitsConfiguration: {
      type: Array,
      default: () => [],
    },
    unitError: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default: '',
    },
    startDateError: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    endDateError: {
      type: Boolean,
      default: false,
    },
    disableFields: {
      type: Boolean,
      default: false,
    },
    defaultDataType: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(['mariaCampaign', 'tagList', 'unitsGroups']),
    errorMessages() {
      if (this.startDateError === 'A data de envio deve ser no futuro') return this.startDateError
      return this.startDateError || this.endDateError ? 'Selecione o período de validade' : ''
    },
    minInitialDate() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    allUnits() {
      return this.$store.getters.units
    },
    selectedUnits: {
      get() {
        return this.units
      },
      set(value) {
        this.$emit('update:units', value)
      },
    },
    selectedUnitsConfiguration: {
      get() {
        return this.unitsConfiguration
      },
      set(value) {
        this.$emit('update:unitsConfiguration', value)
      },
    },
    selectedStartDate: {
      get() {
        return this.startDate
      },
      set(value) {
        this.$emit('update:startDate', value)
      },
    },
    selectedEndDate: {
      get() {
        return this.endDate
      },
      set(value) {
        this.$emit('update:endDate', value)
      },
    },
  },
}
</script>

<style lang="scss">
.product-details-actions {
  &-subtitle {
    color: $cinza-0;
    font-weight: 400;
    font-size: 14px;
    margin: 0;
  }
}
</style>
